module.exports = __webpack_public_path__ + "static/media/cerisaie03.55b3ae7e.jpg";